import * as React from 'react';

const ConfirmEligibility = () => <div>test</div>;
export default ConfirmEligibility;
